/* eslint-disable max-len */
import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'icon-buttons-grid',
  templateUrl: './icon-buttons-grid.component.html',
  styleUrls: ['./icon-buttons-grid.component.scss'],
})
export class IconButtonsGridComponent implements OnInit {
  @Input() buttonsInfo: any;
  @Input() airportInfo: any;
  private url: any;
  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  navigateToPage(link, title) {
    this.analyticsService.trackUnified('airport_icon_clicked', {
      flow: 'airport',
      outcome: 'success',
      legacy_event_name: 'icon_clicked',
      component: 'hero-banner-component',
      icon: title,
    });
    if (link) {
      if (title === 'Map') {
        this.navController.navigateForward([link], {
          queryParams: {
            latitude: this.airportInfo.latitude,
            longitude: this.airportInfo.longitude,
          },
        });
      } else {
        this.navController.navigateForward(link);
      }
    } else {
      this.navController.navigateForward('/home');
    }
  }
}
